import React from 'react';
import autoRenewalsRoutes from './autorenewals/AutoRenewalsRoutes';
import biologicalRoutes from './biological/BiologicalRoutes';
import dashboardRoutes from './dashboard/DashboardRoutes';
import deRoutes from './dentalenhancements/DERoutes';
import medsDevicesRoutes from './meds-devices/MedsDevices';
import reportsRoutes from './reports/ReportsRoutes';
import shipmentRoutes from './shipments/ShipmentRoutes';
import tasksRoutes from './tasks/TasksRoutes';
import teamMembersRoutes from './team-members/TeamMembers';
import trainingRoutes from './training/TrainingRoutes';
import wasteManagementRoutes from './wastemanagement/WasteManagementRoutes';
import waterlineRoutes from './waterline/WaterlineRoutes';

import Contact from '../../views/common/Contact';
import Faq from '../../views/common/Faq';
import Guides from '../../views/common/Guides';
import PrivacyPolicy from '../../views/common/PrivacyPolicy';
import Settings from '../../views/practice/settings/Settings';
import SDS from '../../views/practice/sds/SDS';
import Terms from '../../views/common/Terms';
import PaymentRedirect from '../../components/PaymentRedirect';

const miscRoutes = [
  {
    path: '/practice/contact',
    element: <Contact />
  },
  {
    path: '/practice/faq',
    element: <Faq />
  },
  {
    path: '/practice/terms',
    element: <Terms />
  },
  {
    path: '/practice/privacy-policy',
    element: <PrivacyPolicy />,
  },
  {
    path: '/practice/guides',
    element: <Guides />
  },
  {
    path: '/practice/settings',
    element: <Settings />
  },
  {
    path: '/practice/sds',
    element: <SDS />
  },
  {
    path: '/practice/payment',
    element: <PaymentRedirect fallbackPath="/practice/dashboard" />
  }
];

const practiceRoutes = [
  ...miscRoutes,
  ...autoRenewalsRoutes,
  ...biologicalRoutes,
  ...dashboardRoutes,
  ...deRoutes,
  ...medsDevicesRoutes,
  ...shipmentRoutes,
  ...tasksRoutes,
  ...reportsRoutes,
  ...teamMembersRoutes,
  ...trainingRoutes,
  ...wasteManagementRoutes,
  ...waterlineRoutes
];

export default practiceRoutes;
